import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { signInPage } from './signInPage';

export const signInPageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [signInPage],
});
